<template>
  <div ref="container"></div>
</template>

<script>
let recaptchaLoader;

function loadRecaptcha() {
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  if (recaptchaLoader) return recaptchaLoader;

  recaptchaLoader = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      'script[src^="https://www.google.com/recaptcha/api.js"]'
    );
    const script = existing || document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = () =>
      window.grecaptcha.ready(() => resolve(window.grecaptcha));
    script.onerror = reject;
    if (!existing) document.head.appendChild(script);
  });

  return recaptchaLoader;
}

export default {
  name: "RecaptchaWidget",
  props: {
    sitekey: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      default: "light",
    },
    size: {
      type: String,
      default: "normal",
    },
  },
  emits: ["verify", "expired", "error", "render"],
  data: () => ({
    widgetId: null,
  }),
  async mounted() {
    try {
      const grecaptcha = await loadRecaptcha();
      this.widgetId = grecaptcha.render(this.$refs.container, {
        sitekey: this.sitekey,
        theme: this.theme,
        size: this.size,
        callback: (token) => this.$emit("verify", token),
        "expired-callback": () => this.$emit("expired"),
        "error-callback": () => this.$emit("error"),
      });
      this.$emit("render", this.widgetId);
    } catch (error) {
      this.$emit("error", error);
    }
  },
  methods: {
    reset() {
      if (window.grecaptcha && this.widgetId !== null) {
        window.grecaptcha.reset(this.widgetId);
      }
    },
    execute() {
      if (window.grecaptcha && this.widgetId !== null) {
        try {
          const result = window.grecaptcha.execute(this.widgetId);
          if (result && typeof result.then === "function") {
            return result.catch((error) => {
              this.$emit("error", error);
              return Promise.reject(error);
            });
          }
          return result;
        } catch (error) {
          this.$emit("error", error);
          return Promise.reject(error);
        }
      }
      const err = new Error("reCAPTCHA no está listo");
      this.$emit("error", err);
      return Promise.reject(err);
    },
  },
};
</script>
